import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import api from "@/lib/apiClient";
import { localizedPath, useLang } from "@/lib/i18n";
import { instrumentCoverSrc } from "@/lib/instrumentSeo";
import { pickNextTests } from "@/lib/nextTests";

export default function NextTests({ currentSlug }) {
  const { lang, pick } = useLang();
  const [instruments, setInstruments] = useState([]);

  useEffect(() => {
    let active = true;
    api.get("/public/instruments")
      .then((r) => { if (active) setInstruments(Array.isArray(r.data) ? r.data : []); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const next = pickNextTests(instruments, currentSlug);
  if (!next.length) return null;

  return (
    <section className="mt-10 print:hidden" data-testid="next-tests">
      <h2 className="font-display text-2xl tracking-tight mb-1">{lang === "id" ? "Tes berikutnya" : "Try another test"}</h2>
      <p className="text-sm text-muted-foreground mb-4">
        {lang === "id" ? "Kenali dirimu lebih jauh lewat tes lainnya." : "Keep getting to know yourself with another test."}
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {next.map((inst) => (
          <Link
            key={inst.id || inst.slug}
            to={localizedPath(`/instruments/${inst.slug}`, lang)}
            data-testid={`next-test-${inst.slug}`}
            className="group flex gap-3 sm:block rounded-2xl border border-border bg-card overflow-hidden hover:shadow-lg transition-shadow"
          >
            <div className="relative w-24 min-h-[7.5rem] sm:min-h-0 sm:w-full shrink-0 sm:aspect-[16/10] overflow-hidden bg-secondary">
              <img src={instrumentCoverSrc(inst, lang)} alt="" loading="lazy" className="absolute inset-0 w-full !h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-4 min-w-0 space-y-2">
              <h3 className="font-display text-lg leading-snug break-words">{pick(inst, "name")}</h3>
              <p className="text-xs text-muted-foreground line-clamp-2">{pick(inst, "short_description")}</p>
              <div className="flex items-center justify-between gap-2 text-xs text-muted-foreground">
                {inst.duration_minutes ? (
                  <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {inst.duration_minutes} {lang === "id" ? "menit" : "min"}</span>
                ) : <span />}
                <span className="flex items-center gap-1 text-terracotta-700 font-medium">
                  {lang === "id" ? "Mulai" : "Start"} <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
